
export default {
  paramNames: ['targetValue'],
  options: {
    hasTarget: true
  },
  validate: function (value, ref) {
    var targetValue = ref.targetValue

    return String(value) !== String(targetValue)
  }
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/distinct.js